import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./styles/ShowRaceDetail.css";

const ShowRaceDetail = () => {
  const { t } = useTranslation();

  const [raceDetail, setRaceDetail] = useState(null);
  const [raceData, setRaceData] = useState(null);

  const { idRace } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    const fetchRaceDetail = async () => {
      try {
        const response = await fetch(`${apiUrl}/get-race-detail/${idRace}`);
        if (!response.ok) {
          throw new Error(t("raceDetail.errors.fetchRaceDetail"));
        }
        const data = await response.json();
        setRaceDetail(data);
      } catch (error) {
        console.error("Erreur:", error);
      }
    };

    fetchRaceDetail();
  }, [apiUrl, idRace, t]);

  useEffect(() => {
    if (raceDetail && new Date(raceDetail.date_end) < new Date()) {
      fetch(`${apiUrl}/race-ranking/${idRace}`)
        .then((response) => {
          if (!response.ok) throw new Error(t("raceDetail.errors.fetchRanking"));
          return response.json();
        })
        .then((data) => {
          if (Array.isArray(data)) {
            setRaceData({ rankings: data, participants: [] });
          } else {
            setRaceData({
              rankings: Array.isArray(data.rankings) ? data.rankings : [],
              participants: Array.isArray(data.participants) ? data.participants : [],
            });
          }
        })
        .catch((error) => console.error("Erreur:", error));
    }
  }, [apiUrl, idRace, raceDetail, t]);

  const participantsSorted = (raceData?.participants || [])
    .slice()
    .sort((a, b) => (b.racePoints || 0) - (a.racePoints || 0));

  return (
    <main className="show-race-detail">
      <h1>{t("raceDetail.title")}</h1>

      {raceDetail ? (
        <div className="show-race-detail-course">
          <p>
            {t("raceDetail.labels.name")}: {raceDetail.name}
          </p>
          <p>
            {t("raceDetail.labels.step")}: {raceDetail.step}
          </p>
          <p>
            {t("raceDetail.labels.startDate")}: {formatDate(raceDetail.date_start)}
          </p>
          <p>
            {t("raceDetail.labels.endDate")}: {formatDate(raceDetail.date_end)}
          </p>
          <p>
            {t("raceDetail.labels.category")}: {raceDetail.category}
          </p>

          <h2>{t("raceDetail.raceRankingTitle")}</h2>
          {raceData && (raceData.rankings?.length || 0) > 0 ? (
            <div className="show-race-detail-table">
              <div className="show-race-detail-table-container">
                <table>
                  <thead>
                    <tr>
                      <th>{t("raceDetail.table.position")}</th>
                      <th>{t("raceDetail.table.riderName")}</th>
                      <th>{t("raceDetail.table.points")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {raceData.rankings.map((ranking, index) => (
                      <tr key={`${ranking.rider_name}-${index}`}>
                        <td>{ranking.position}</td>
                        <td>{ranking.rider_name}</td>
                        <td>{ranking.points}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <p className="show-race-detail-empty">{t("raceDetail.empty.raceRanking")}</p>
          )}

          <h2>{t("raceDetail.playersRankingTitle")}</h2>
          {participantsSorted.length > 0 ? (
            <div className="show-race-detail-table">
              <div className="show-race-detail-table-container">
                <table>
                  <thead>
                    <tr>
                      <th>{t("raceDetail.table.position")}</th>
                      <th>{t("raceDetail.table.pseudo")}</th>
                      <th>{t("raceDetail.table.points")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {participantsSorted.map((p, idx) => (
                      <tr key={`${p.userId}-${idx}`}>
                        <td>{idx + 1}</td>
                        <td>{p.pseudo}</td>
                        <td>{p.racePoints}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <p className="show-race-detail-empty">{t("raceDetail.empty.playersRanking")}</p>
          )}
        </div>
      ) : (
        <p className="show-race-detail-empty">{t("raceDetail.loading")}</p>
      )}
    </main>
  );
};

export default ShowRaceDetail;
